module.exports = __webpack_public_path__ + "static/media/google.2d5b0ba1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login/google.svg
// module id = 1353
// module chunks = 0